import { ActiveUplink, ContactTypeValue } from '../enums';

// Map ContactTypeValue to the old contact_types names, which the API returns until the apps move to ContactTypeValue
export const legacyContactTypeNameMap: Record<ContactTypeValue, string> = {
  [ContactTypeValue.PRIMARY_CONTACT]: 'Primary Contact',
  [ContactTypeValue.SECONDARY_CONTACT]: 'Secondary Contact',
  [ContactTypeValue.AUXILIARY_CONTACT]: 'Auxiliary Contact',
  [ContactTypeValue.INSTALL_MANAGER]: 'Install Manager',
  [ContactTypeValue.SALES_OWNER]: 'Sales Owner',
  [ContactTypeValue.SERVICE_OWNER]: 'Service Owner',
};

// Map Inhand's _active_link values to our ActiveUplink enum
// Use with ?? null to default to null for unmapped values
export const inhandActiveUplinkMap: Record<string, ActiveUplink> = {
  wan0: ActiveUplink.ETHERNET,
  wan1: ActiveUplink.CELLULAR,
};

// The disposition codes the CDR table filters on individually - anything
// else falls under the "Other" filter option.
export const ALLOWED_CDR_SIP_CODES = [200, 404, 486, 503, 603];

export const cdrSipCodeMap: Record<number, string> = {
  0: 'Invalid Sip Response Code',
  200: 'OK',
  403: 'Forbidden',
  404: 'Not Found',
  408: 'Request Timeout',
  418: "I'm a teapot",
  480: 'Temporarily Unavailable',
  482: 'Loop Detected',
  484: 'Address Incomplete',
  486: 'Busy Here',
  487: 'Request Terminated',
  500: 'Internal Server Error',
  503: 'Service Unavailable',
  504: 'Server Time-Out',
  603: 'Decline',
  604: 'Does Not Exist Anywhere',
  606: 'Not Acceptable',
};
